var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHalloweenBroom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18800_33116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6103 16.2256C23.8285 16.4 23.976 16.6477 24.0253 16.9227C24.0746 17.1977 24.0223 17.4812 23.8783 17.7206L21.9493 21.6266L18.0433 23.5556C17.8035 23.701 17.5189 23.754 17.2427 23.7047C16.9666 23.6553 16.718 23.5071 16.5433 23.2876L13.5043 18.6166C12.9095 17.873 12.6098 16.9362 12.6626 15.9854C12.7154 15.0347 13.1169 14.1368 13.7903 13.4636C14.4636 12.7906 15.3614 12.3894 16.3119 12.3368C17.2624 12.2842 18.1989 12.5839 18.9423 13.1786L23.6103 16.2256Z",
    stroke: "#8A8A8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2933 10.9706L1.56531 1.22058",
    stroke: "#8A8A8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8443 14.9997L11.2933 13.4707C10.9618 13.1391 10.7756 12.6895 10.7756 12.2207C10.7756 11.7518 10.9618 11.3022 11.2933 10.9707C11.6248 10.6392 12.0745 10.4529 12.5433 10.4529C13.0121 10.4529 13.4617 10.6392 13.7933 10.9707L15.3553 12.5107",
    stroke: "#8A8A8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4433 22.3706L17.2933 19.2206",
    stroke: "#8A8A8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9773 19.5456L19.5433 16.9706",
    stroke: "#8A8A8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5653 7.22058H21.0653",
    stroke: "#8A8A8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8153 4.97058V9.47058",
    stroke: "#8A8A8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.81531 2.72058H12.8153",
    stroke: "#8A8A8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3153 1.22058V4.22058",
    stroke: "#8A8A8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.56531 12.4706H4.56531",
    stroke: "#8A8A8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.06531 10.9706V13.9706",
    stroke: "#8A8A8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.31531 22.2206H11.3153",
    stroke: "#8A8A8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.81531 20.7206V23.7206",
    stroke: "#8A8A8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8422 2.72058C21.6351 2.72058 21.4672 2.55269 21.4672 2.34558C21.4672 2.13848 21.6351 1.97058 21.8422 1.97058",
    stroke: "#8A8A8A",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8422 2.72058C22.0493 2.72058 22.2172 2.55269 22.2172 2.34558C22.2172 2.13848 22.0493 1.97058 21.8422 1.97058",
    stroke: "#8A8A8A",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.74426 21.4056C3.53716 21.4056 3.36926 21.2377 3.36926 21.0306C3.36926 20.8235 3.53716 20.6556 3.74426 20.6556",
    stroke: "#8A8A8A",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.74426 21.4056C3.95137 21.4056 4.11926 21.2377 4.11926 21.0306C4.11926 20.8235 3.95137 20.6556 3.74426 20.6556",
    stroke: "#8A8A8A",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.14624 17.4926C7.93913 17.4926 7.77124 17.3247 7.77124 17.1176C7.77124 16.9105 7.93913 16.7426 8.14624 16.7426",
    stroke: "#8A8A8A",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.14624 17.4927C8.35335 17.4927 8.52124 17.3248 8.52124 17.1177C8.52124 16.9106 8.35335 16.7427 8.14624 16.7427",
    stroke: "#8A8A8A",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18800_33116"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.804321 0.47168)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalloweenBroom);
export default __webpack_public_path__ + "static/media/halloween-broom.d7ca4f1badb3c801a1a76fd1e86c3703.svg";
export { ForwardRef as ReactComponent };